// 智能合同页面
<template>
  <div>
    <div class="action-box">
      <!-- 文档对比 -->
      <div class="action odd" style="padding-top: 30px">
        <div class="title-txt">
          <span class="divider"></span>
          <span class="title">合同智能处理</span>
          <span class="divider"></span>
        </div>
        <div class="flex row-center">
          <div class="flex">
            <img
              src="../../static/images/AISmart/Mask4.png"
              width="480px"
              height="320px"
              style="margin-right: 20px"
              alt=""
            />
            <div class="flex flex-column row-around" style="height: 320px">
              <div>
                <div class="flex column-center">
                  <img
                    width="44px"
                    height="37px"
                    src="../../static/images/AISmart/contrast.png"
                    alt="智能文档对比"
                  />
                  <span class="titleII">智能文档对比</span>
                  <img
                    width="36px"
                    height="16px"
                    src="../../static/images/AISmart/hot.png"
                    alt=""
                  />
                </div>
                <p style="margin-left: 65px; color: #aaa">
                  当前剩余使用次数：
                  <span style="color: #333; font-weight: bolder">{{
                    canUse(packageTemp.contrast) || 0
                  }}</span>
                </p>
              </div>

              <div style="width: 527px">
                由AI人⼯智能⽐对⽂档差异信息(支持PDF以及全系列word
                文档差异比对，包括doc、docx、xls、xlsx、ppt、pptx;)，差异内容直观可见，导出结果精确可查，⽐对规则灵活配置，⼀键⽣成差异结果。
              </div>
              <div class="flex">
                <el-button type="primary" round @click="buyPackge"
                  >前往购买</el-button
                >
                <el-button round @click="useTurn('/docContrast/contrastList')"
                  >立即使用</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 文档审核 -->
      <div class="action flex row-center column-center">
        <div class="flex flex-column row-around" style="height: 320px">
          <div>
            <div class="flex column-center">
              <img
                width="51px"
                height="48px"
                src="../../static/images/AISmart/receivable.png"
                alt="智能文档审核"
              />
              <span class="titleII">法律风险审核</span>
              <img
                width="36px"
                height="16px"
                src="../../static/images/AISmart/hot.png"
                alt=""
              />
            </div>
            <p style="margin-left: 65px; color: #aaa">
              当前剩余使用次数：
              <span style="color: #333; font-weight: bolder">{{
                canUse(packageTemp.examine) || 0
              }}</span>
            </p>
          </div>

          <div style="width: 527px">
            智能审核基于海量文本语料库、知识库，根据匹配设定的审核规则和RPA机器自动化流程，增加机器审核环节，由浅及深的全面审阅档，按等级智能提示风险，⼀键生成分析报告。(支持doc、docx文字版类型的标准合同审核)
          </div>
          <div class="flex">
            <el-button type="primary" round @click="buyPackge"
              >前往购买</el-button
            >
            <el-button
              round
              class="useNow"
              @click="useTurn('/docExamine/examineList')"
              >立即使用</el-button
            >
          </div>
        </div>
        <img
          src="../../static/images/AISmart/Mask5.png"
          width="480px"
          height="320px"
          style="margin-left: 20px"
          alt=""
        />
      </div>
      <!-- 文档抽取 -->
      <div class="action odd flex row-center column-center">
        <img
          src="../../static/images/AISmart/Mask2.png"
          width="480px"
          height="320px"
          style="margin-right: 20px"
          alt=""
        />
        <div class="flex flex-column row-around" style="height: 320px">
          <div>
            <div class="flex column-center">
              <img
                width="48px"
                height="46px"
                src="../../static/images/AISmart/remote.png"
                alt="智能文档抽取"
              />
              <span class="titleII">合同关键词抽取</span>
              <img
                width="36px"
                height="16px"
                src="../../static/images/AISmart/hot.png"
                alt=""
              />
            </div>
            <p style="margin-left: 65px; color: #aaa">
              当前剩余使用次数：
              <span style="color: #333; font-weight: bolder">{{
                canUse(packageTemp.extract) || 0
              }}</span>
            </p>
          </div>

          <div style="width: 527px">
            智能文档抽取对⽂档（如：合同、裁判⽂书、票据等）的关键信息进⾏抽取，如：主体信息、标的信息、争议解决⽅式等，协助⼯作⼈员完成⾃动填表、内容⼀致性检查等⼯作，让⽂档审阅过程更⾼效。
          </div>
          <div class="flex">
            <el-button type="primary" round @click="buyPackge"
              >前往购买</el-button
            >
            <el-button
              round
              class="useNow"
              @click="useTurn('/docExtract/extractList')"
              >立即使用</el-button
            >
          </div>
        </div>
      </div>
      <!-- 在线起草 -->
      <div class="action flex row-center column-center">
        <div class="flex flex-column row-around" style="height: 320px">
          <div>
            <div class="flex column-center">
              <img
                width="51px"
                height="48px"
                src="../../static/images/AISmart/clickEdit.png"
                alt="合同协同起草"
              />
              <span class="titleII">合同协同起草</span>
              <img
                width="36px"
                height="16px"
                src="../../static/images/AISmart/hot.png"
                alt=""
              />
            </div>
            <p style="margin-left: 65px; color: #aaa">
              当前剩余使用次数：
              <span style="color: #333; font-weight: bolder">{{
                canUse(packageTemp.draft) || 0
              }}</span>
            </p>
          </div>

          <div style="width: 527px">
            基于权威、专业的知识库，由业内顶尖专业⼈⼠构建覆盖企业20类领域的标准合同模板，每⼀条款设计都源⾃真实的实践案例和法律法规，帮助企业通过交互形式，⾼效、便捷、快速地起草合同/⽂档。
          </div>
          <div class="flex">
            <el-button type="primary" round @click="buyPackge"
              >前往购买</el-button
            >
            <el-button
              round
              class="useNow"
              @click="useTurn('/docDraft/draftList')"
              >立即使用</el-button
            >
          </div>
        </div>
        <img
          src="../../static/images/AISmart/Mask3.png"
          width="480px"
          height="320px"
          style="margin-left: 20px"
          alt=""
        />
      </div>
      <!-- 常用工具 -->
      <div class="action odd common-tools" style="padding-top: 30px">
        <!-- 标题 -->
        <div class="title-txt">
          <span class="divider"></span>
          <span class="title">常用工具</span>
          <span class="divider"></span>
        </div>
        <!-- 工具 -->
        <div class="tools flex row-center">
          <router-link to="/applySign/toCreateDemo">
            <div class="tool coor flex row-center column-center"></div>
            <p class="tool-text">签章坐标查询</p>
          </router-link>
          <router-link to="/blockChain">
            <div class="tool verif flex row-center column-center"></div>
            <p class="tool-text">文件/保全验证</p>
          </router-link>
        </div>
      </div>
    </div>
    <goto-auth :authDialog.sync="authDialog"></goto-auth>
  </div>
</template>

<script>
// 接口
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { mapGetters } from "vuex";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      assets: [],
      packageTemp: {
        contrast: 55,
        contrastLabel: "智能文档对比",
        examine: 56,
        examineLabel: "法律风险审核",
        extract: 57,
        extractLabel: "合同关键词抽取",
        draft: 58,
        draftLabel: "合同在线起草"
      },
      authDialog: false
    };
  },
  // data end
  methods: {
    useTurn (url) {
      if (this.allAuthUser.accountInfoVO.identityAuth == -1)
        return this.goToAuth();
      let path = `/smartDoc${url}`;
      this.$router.push({ path });
    },
    // 查询套餐次数
    queryNum () {
      this.smartAPI.packageList().then(res => {
        if (res.success) {
          this.assets = res.data;
        } else {
          if (res.code === "10402") {
            this.authDialog = true;
          } else {
            this.$message.error(res.description);
          }
        }
      });
    },
    // 根据值返回套餐数量
    canUse (key) {
      for (let i = 0; i < this.assets.length; i++) {
        const elem = this.assets[i];
        //! assetItem 53 比对 54 审核 55 抽取 56 合同在线起草
        if (elem.assetItem == key) {
          //! elem.nolimit。 true 说明是不限次数 elem.remainCnt 剩余次数
          if (elem.nolimit) return "不限";
          if (!elem.nolimit) return elem.remainCnt;
        }
      }
    },
    // 购买页面
    buyPackge () {
      if (this.allAuthUser.accountInfoVO.identityAuth == -1) {
        return this.goToAuth();
      }
      const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
      isInDingTalk ? location.href = url : window.open(url);
    },
    // 未实名
    goToAuth () {
      // allAuthUser.accountInfoVO
      this.authDialog = true;
    }
  },
  // methods end
  mounted () {
    this.queryNum();
  },
  // mounted
  computed: {
    // 新增状态辅助函数减少冗余代码
    ...mapGetters(["allAuthUser"])
  }
};
</script>

<style scoped lang="less">
.action-box {
  .action {
    width: 100%;
    height: 540px;
  }
  .odd {
    background-color: #f6fafd;
  }
  > div:nth-child(2),
  > div:nth-child(4) {
    background-color: #eff2fb;
  }
  .tools {
    .tool {
      width: 468px;
      height: 225px;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      box-shadow: 0px 0px 3px 0px #d1cccc;
      border-radius: 5px;
    }
    .tool-text {
      font-size: 26px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
      color: #b3acac;
    }
    .coor {
      background-image: url("/images/AISmart/Mask1.png");
    }
    .verif {
      margin-left: 73px;
      background-image: url("/images/AISmart/Mask.png");
    }
  }
}
.title-txt {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 70px;
  span {
    display: block;
  }
  .divider {
    width: 138px;
    border: 2px solid #e6eaed;
  }
  .title {
    font-size: 28px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin: 0 5px;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
}
.titleII {
  font-size: 32px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 0 9px 0 21px;
}
.useNow {
  margin-left: 20px;
}
.flex {
  display: flex;
}
.row-center {
  justify-content: center;
}
.row-around {
  justify-content: space-around;
}
.column-center {
  align-items: center;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// pages/smartContract/index.vue